import { useEffect, useState } from 'react'
import {
  mergeUpdateObjectAtIndex,
  updateObjectWithMatchingId,
} from '../../utils/array'
import useGenericEndpoint from './useGenericEndpoint'

const useCustomerTickets = (customerId) => {
  const shouldPreventCall = customerId === 'new'
  const url = `/api/customer/${customerId}/ticket`

  const [tickets, setTickets] = useState([])

  const { data, hasLoadError, isLoading } = useGenericEndpoint(url, {
    shouldPreventCall,
  })

  const addNote = (ticketId, note) => {
    const ticket = tickets.find((t) => t.id === ticketId)
    const index = tickets.indexOf(ticket)

    setTickets(
      mergeUpdateObjectAtIndex(
        tickets,
        { notes: [note, ...(ticket.notes || [])] },
        index
      )
    )
  }

  const editNote = (ticketId, note) => {
    const ticket = tickets.find((t) => t.id === ticketId)
    const index = tickets.indexOf(ticket)

    setTickets(
      mergeUpdateObjectAtIndex(
        tickets,
        { notes: updateObjectWithMatchingId(ticket.notes, note) },
        index
      )
    )
  }

  const removeNote = (ticketId, note) => {
    const ticket = tickets.find((t) => t.id === ticketId)
    const index = tickets.indexOf(ticket)

    setTickets(
      mergeUpdateObjectAtIndex(
        tickets,
        { notes: ticket.notes.filter((n) => n.id !== note.id) },
        index
      )
    )
  }

  useEffect(() => {
    if (!data || isLoading || hasLoadError) return

    setTickets(data.tickets)
  }, [data, isLoading, hasLoadError])

  return {
    hasLoadError,
    isLoading,
    tickets,
    setTickets,
    addNote,
    editNote,
    removeNote,
  }
}

export default useCustomerTickets
